import { createContext } from "react";
var SnackbarInitialState = {
  open: false,
  message: ''
};
var shoppingCartInitialState = {
  courseIdsInCart: [],
  bundleIdsInCart: [],
  // Fetching cart data loading status
  loadingCart: true,
  // Executing cart mutation status (adding or removing item to the cart)
  loadingCartMutation: false,
  nextDiscount: 0,
  cartSummary: {
    idCart: null,
    totalOff: null,
    dataExtraDiscount: null,
    currencySymbol: null,
    totalPrice: null,
    totalRealPrice: null
  },
  items: [],
  courses: [],
  bundles: [],
  showShoppingCartPopup: false,
  lastItemAdded: null,
  fetchShoppingCartPopupChunk: false,
  lastItemAddedType: null,
  flagClassicShoppingCart: false,
  enableCumulativeDiscount: true
};
export var initialState = {
  shoppingCartState: shoppingCartInitialState,
  SnackbarState: SnackbarInitialState,
  /* Shopping cart methods */
  addCourseToCart: function addCourseToCart() {
    return Promise.resolve();
  },
  removeCourseFromCart: function removeCourseFromCart() {
    return Promise.resolve();
  },
  closeShoppingCartPopup: function closeShoppingCartPopup() {},
  addBundleToCart: function addBundleToCart() {
    return Promise.resolve();
  },
  removeBundleFromCart: function removeBundleFromCart() {
    return Promise.resolve();
  },
  setBasicDataForm: function setBasicDataForm() {},
  showShoppingCartPopup: function showShoppingCartPopup() {}
};
export var ProductsContext = /*#__PURE__*/createContext(initialState);
export default ProductsContext;